module.exports = __webpack_public_path__ + "img/delano5.290bee7d.jpg";